import * as React from "react";
import { forwardRef } from "react";
const ArrowTurnRightSVG = (props, ref) => React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", ref: ref, ...props },
    React.createElement("g", { clipPath: "url(#prefix__clip0_5876_1440)" },
        React.createElement("path", { fillRule: "evenodd", d: "M4 1a1 1 0 0 1 1-1h6a1 1 0 0 1 .928 1.371l-2 5a1 1 0 0 1-1.856-.742L9.22 2.757C7.257 3.88 6 5.839 6 8c0 2.829 2.153 5.311 5.227 6.026a1 1 0 0 1-.453 1.948C6.946 15.084 4 11.907 4 8c0-2.393 1.106-4.512 2.842-6H5a1 1 0 0 1-1-1", clipRule: "evenodd" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "prefix__clip0_5876_1440" },
            React.createElement("path", { d: "M0 0h16v16H0z" }))));
const ForwardRef = forwardRef(ArrowTurnRightSVG);
export default ForwardRef;
//# sourceMappingURL=ArrowTurnRight.js.map